/*
|--------------------------------------------------------------------------
| Views: Magazine
|--------------------------------------------------------------------------
*/
/**
 * Magazine
 * @namespace
 */
__gh__webApp.views.magazine = {

	"getSubView": function(bucket){
		var commonJS			= __gh__webApp.common,
			items 				= (bucket.items.main) ? bucket.items.main : {},
			commonViewJS		= __gh__webApp.views.common,
			viewFolder		 	= "buckets/magazine",
			viewName, hasImage;

		viewName 		= viewFolder+"/default";
		itemCount 		= (bucket.hasAd) ? 2 : 3;

		hasImages = __gh__webApp.data.itemValidator({
			"data": 			items.slice(0, itemCount),
			"required": 		itemCount,
			"validationMethod": "hasImage"
		});
		if(hasImages === false) {
			for(var i = 0; i < items.length; i++) {
				if(typeof items[i].image.link !== 'string') {
					items.splice(i, 1);
					i--;
				}
			}
		}

		getItems		= commonViewJS.splitItems(items,itemCount,bucket);

		bucket.view.name 	= viewName;
		bucket.items = {
			"main": getItems.main,
		};
		return bucket;


	}
};